module.exports = __webpack_public_path__ + "static/img/logo.e25a5eb9.png";